import { createSlice } from "@reduxjs/toolkit";

const initialGuidesState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  guideForEdit: undefined,
  lastError: null,
  pageNumber: 1,
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const guidesSlice = createSlice({
  name: "guides",
  initialState: initialGuidesState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getGuideById
    guideFetched: (state, action) => {
      state.actionsLoading = false;
      state.guideForEdit = action.payload.guideForEdit;
      state.error = null;
    },
    // findGuides
    guidesFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createGuide
    guideCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
    },
    // pageNumberUpdated
    pageNumberUpdated: (state, action) => {
      const { pageNumber } = action.payload;
      state.pageNumber = pageNumber;
    },
    // updateGuide
    guideUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
    },
    // deleteGuide
    guideDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
    },
    // deleteGuides
    guidesDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter((el) => !action.payload.ids.includes(el.id));
    },
    // guidesUpdateState
    guidesStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map((entity) => {
        if (ids.findIndex((id) => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    },
  },
});
